import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useTheme } from "../ThemeContext";
import "./Login.css";

export default function Login() {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);
  const { login } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch {
      setError("Invalid email or password. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-brand">
          <div className="login-logo-mark">⬡</div>
          <div>
            <div className="login-brand-name">CommPro</div>
            <div className="login-brand-sub">Powered by Rosegate</div>
          </div>
        </div>
        <div className="login-hero-text">
          <h1>Commission management,<br/><span>simplified.</span></h1>
          <p>Track loans, manage commissions, and handle exceptions — all in one place built for mortgage professionals.</p>
        </div>
        <div className="login-features">
          <div className="login-feature">✓ Real-time commission tracking</div>
          <div className="login-feature">✓ Multi-level exception approvals</div>
          <div className="login-feature">✓ Role-based access control</div>
          <div className="login-feature">✓ Excel import & API ready</div>
        </div>
      </div>

      <div className="login-right">
        <button className="theme-toggle-login" onClick={toggleTheme}>
          {theme === "light" ? "🌙 Dark" : "☀️ Light"}
        </button>

        <div className="login-card">
          <h2>Welcome back</h2>
          <p className="login-card-sub">Sign in to your CommPro account</p>

          <form onSubmit={handleSubmit} className="login-form">
            {error && <div className="login-error">{error}</div>}

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@rosegate.com"
                required autoFocus
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            <button type="submit" className="btn-primary login-btn" disabled={loading}>
              {loading ? "Signing in..." : "Sign In →"}
            </button>
          </form>

          <p style={{ textAlign: "center", marginTop: "16px", fontSize: "14px", color: "var(--text-muted)" }}>
            <Link to="/forgot-password" style={{ color: "var(--primary)" }}>Forgot your password?</Link>
          </p>
        </div>

        <p className="login-footer">
          © {new Date().getFullYear()} Rosegate Mortgage · CommPro
        </p>
      </div>
    </div>
  );
}
